export enum NotificationToastBlock {
  Root = 'NotificationToast',
}
